import { logout } from './logout';
import { getLocalAuthenticationToken, hasLocalTokens } from './token';

type GetAuthorizationReturnType = {
  Authorization: string;
};

export const CredentialsProvider = {
  isAuthenticated: (): boolean => hasLocalTokens(),
  getAuthorizationHeader: (): GetAuthorizationReturnType => {
    const token = getLocalAuthenticationToken();

    return {
      Authorization: token ? `Bearer ${token}` : '',
    };
  },
  onExpireSession: (): void => logout(),
};
